import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $(window).on('resize scroll',function(){
        var allgood = true;
        $('.px-programs-list .orgs').each(function(){
            $(this).css('margin-top','-'+$(this).find('p').outerHeight()+'px');
            if($(this).hasClass('is-logo')){
                console.log($(this).find('img').height());
                if($(this).find('img').height() == 0){
                    allgood=false;
                }
            }
        })
        if(!allgood){
            console.log('doitagain')
            window.setTimeout(function(){
                $(window).trigger('resize');
            },300);       
        }
    }).trigger('resize');
    $('.px-programs-map .province .open,.px-programs-map .province .marker').on('click',function(){
        $('[name="px_prog_prov"]').val($(this).attr('data-id'));
        redoSearch();
    })
    $('.px-programs-list select').on('change',redoSearch)
    redoSearch();
})
function redoSearch(){
    //console.clear();
    var px_prog_prov = $('[name="px_prog_prov"] option:selected').val();
    var px_prog_org = $('[name="px_prog_org"] option:selected').val();
    var px_prog_venture = $('[name="px_prog_venture"] option:selected').val();
    var px_prog_length = $('[name="px_prog_length"] option:selected').val();
    if(!px_prog_prov && !px_prog_org && !px_prog_venture && !px_prog_length){
        $(".programcard").parent().removeClass('uk-hidden');
    }else{
        var elmnt = document.getElementById("programs-list");
        elmnt.scrollIntoView();
        var delay=0;
        $('.px-programs-map .province').each(function(){
            if($(this).attr('data-id') === px_prog_prov){
                $(this).addClass('is-active');
            }else{
                $(this).removeClass('is-active');
            }
        })
        $('.programcard').parent().addClass('uk-hidden');
        $('.programcard').parent().removeClass('px-animation is-fade-bottom');
        window.setTimeout(function(){
            $(".programcard").each(function(){
                var toshow = false;
                var el_px_prog_prov = $(this).attr('px_prog_prov');
                var el_px_prog_org = $(this).attr('px_prog_org');
                var el_px_prog_venture = $(this).attr('px_prog_venture');
                var el_px_prog_length = $(this).attr('px_prog_length');
                console.info($(this).find('h3').html())
                if(el_px_prog_prov.includes(px_prog_prov) && el_px_prog_prov != '' && px_prog_prov != ''){
                    toshow = true;
                    console.log('prov triggered');
                }
                if(el_px_prog_org.includes(px_prog_org) && el_px_prog_org != '' && px_prog_org != ''){
                    toshow = true;
                    console.log('org triggered');
                }
                if(el_px_prog_venture.includes(px_prog_venture) && el_px_prog_venture != '' && px_prog_venture != ''){
                    toshow = true;
                    console.log('vent triggered');
                }
                if(el_px_prog_length.includes(px_prog_length) && el_px_prog_length != '' && px_prog_length != ''){
                    toshow = true;
                    console.log('length triggered');
                }
                if(toshow){
                    $(this).parent().attr('style','animation-delay:'+delay+'s');
                    $(this).parent().removeClass('uk-hidden');
                    $(this).parent().addClass('px-animation is-fade-bottom');
                    delay+=0.1;
                }else{
                    $(this).parent().addClass('uk-hidden');
                    $(this).parent().removeClass('px-animation is-fade-bottom');
                }
            })
        },50)
    }
}